import { useState, useEffect } from "react";

export default function usePagination(fetchFunction, deps = []) {

  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  async function loadItems() {

    if (loading) return;

    setLoading(true);

    try {

      const res = await fetchFunction(page);

      const newItems = res.data.results || res.data || [];

      setItems(prev => {

        const unique = newItems.filter(
          item => !prev.some(p => p.id === item.id)
        );

        return [...prev, ...unique];

      });

    } catch (err) {

      console.log("Pagination error:", err);

    } finally {

      setLoading(false);

    }

  }

  // load when page changes
  useEffect(() => {
    loadItems();
  }, [page, ...deps]);

  // infinite scroll
  useEffect(() => {

    const handleScroll = () => {

      if (
        !loading &&
        window.innerHeight + document.documentElement.scrollTop
        >= document.documentElement.offsetHeight - 50
      ) {
        setPage(prev => prev + 1);
      }

    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);

  }, [loading]);

  function reset() {
    setItems([]);
    setPage(1);
  }

  return {
    items,
    loading,
    setItems,
    page,
    setPage,
    reset
  };
}